require('./bootstrap');

$(function() {
    'use strict';

    if($('.dashboardDate').length) {
        var date = new Date();
        var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        $('.dashboardDate').datepicker({
            format: "dd.mm.yyyy",
            todayHighlight: true,
            autoclose: true
        });
        //$('.dashboardDate').datepicker('setDate', today);
    }
});

$(document).ready( function () {
    $('#gnTable').DataTable();
} );

$(document).ready( function () {
    let gvContainers = $('.gvContainer');
    //console.log('gv',gvContainers);
    if(gvContainers){

        gvContainers.each(function() {
            let container = $(this);
            let id = container.attr('data-ts');
            //console.log('container',container);
            let button = $(container).find('button');
            //console.log('button',button);
            $(button).click(function(){
                console.log('genereate reports for '+ id);

                let checks = container.find('.gvCheck:checked');
                let requestDataRemove = {};
                let requestDataAdd = {};

                if(checks.length > 0){
                    checks.each(function(){
                        let check = $(this);
                        let ma = check.attr('data-ma');
                        let uid = check.attr('data-uid');
                        console.log(ma);
                        if(check.hasClass('gvCheckRemove')){
                            let data = check.attr('data-cr');
                            requestDataRemove[ma] = {
                                "data": data,
                                "uid": uid,
                                "ma": ma,
                                "date": id
                            }
                            console.log(data, requestDataRemove);
                        }
                        else {
                            let data = check.attr('data-cr');
                            requestDataAdd[ma] = {
                                "data": data,
                                "uid": uid,
                                "ma": ma,
                                "date": id
                            }
                        }

                    })
                    console.log('do somothing', requestDataRemove);


                    if(requestDataRemove ){
                        $('body').removeClass('loaded');
                        $.ajax({
                            type: "POST",
                            url: '/gv/update',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            data: {
                                "crdata": requestDataRemove,
                                "crDataAdd": requestDataAdd
                            },
                            success: function(response) {
                                console.log(response);
                                document.location.reload();
                            },
                            dataType: 'json'
                        });
                    }

                    if(requestDataAdd.length > 0 ){

                    }

                }

                //$('body').removeClass('loaded');
            })
        })
    }
} );
